// @flow

import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import _ from 'lodash';

type Props = {
  title: string,
  description: string,
  imageUrl: string,
  children: Array<React$Element<any>> | React$Element<any> | null,
  isEnterprise: Boolean,
  agencyName: String,
};

const mapStateToProps = state => ({
  isEnterprise:
    _.get(state, 'siteConfigs.partnerAgencyInfo.partnerInfo.partnershipType', '') ===
      'ENTERPRISE' ||
    _.get(state, 'siteConfigs.partnerAgencyInfo.partnerInfo.partnershipType', '') === 'WHITE_LABEL',
  agencyName: _.get(state, 'siteConfigs.brandSiteConfig.name'),
});

class HtmlHead extends PureComponent<Props> {
  static defaultProps = {
    title: 'Stride Health',
    description:
      'We help people working for themselves save money and time on insurance and taxes. Simple, fast and affordable coverage and support.',
    imageUrl:
      'https://images.ctfassets.net/yjgtqlbfutxo/3CwyGqwPGfTUANm5EfJmb2/c14b59ac38bd17323d19811880a50e08/share.png',
    children: null,
  };

  render() {
    const { isEnterprise, agencyName, title } = this.props;
    const agency = isEnterprise ? agencyName : 'Stride Health';
    const titleTxt = title.replace('Stride Health', agency);
    return (
      <Helmet>
        <title>{titleTxt}</title>
        <meta name="description" content={this.props.description} />
        <meta property="og:title" content={this.props.title} />
        <meta property="og:description" content={this.props.description} />
        <meta property="og:image" content={this.props.imageUrl} />
        <meta name="twitter:title" content={this.props.title} />
        <meta name="twitter:description" content={this.props.description} />
        <meta name="twitter:image" content={this.props.imageUrl} />
        {this.props.children}
      </Helmet>
    );
  }
}

export default connect(mapStateToProps)(HtmlHead);
